import React from "react";
import styled from "styled-components";


const IconIMGWrapper = styled.img`
object-fit: center;
width: ${(props)=> props.width ? props.width : '50px'};
height: ${(props)=>props.height ? props.height : '50px'};

`
export const IconIMG = ({width, height, icon})=>{
    return (
        <>
            <IconIMGWrapper src={icon} width={width} height={height} />
        </>
    )
}